import type { ReactNode } from 'react';

import IntersectionReveal from '../intersection/IntersectionReveal';

type Props = {
  children: ReactNode;
  delay?: number;
  duration?: number;
  ease?: string;
  once?: boolean;
};

export default function AniFadeOut({
  children,
  delay = 0,
  duration = 0.5,
  ease = 'power1.out',
  once = true,
}: Props) {
  return (
    <IntersectionReveal
      delay={delay}
      duration={duration}
      ease={ease}
      hiddenOpacity={1}
      once={once}
      visibleOpacity={0}
    >
      {children}
    </IntersectionReveal>
  );
}
